import ZoomInRoundedIcon from '@mui/icons-material/ZoomInRounded'
import ZoomOutRoundedIcon from '@mui/icons-material/ZoomOutRounded'
import { IconButton, Stack, Slider } from '@mui/material'

type OwnProps = {
  onChangeZoom: (e: 'inc' | 'dec' | number) => void
  zoom: number
}

const ZoomButtons = ({ zoom, onChangeZoom }: OwnProps) => {
  return (
    <Stack alignItems="center" direction="row" width="160px">
      <IconButton
        aria-label="Уменьшить"
        id="act-view-zoom-out"
        onClick={() => onChangeZoom('dec')}
      >
        <ZoomOutRoundedIcon />
      </IconButton>
      <Slider
        aria-label="zoom"
        size="small"
        value={zoom * 100}
        onChange={(_e, v) => onChangeZoom((v as number) / 100)}
      />
      <IconButton
        aria-label="Увеличить"
        id="act-view-zoom-in"
        onClick={() => onChangeZoom('inc')}
      >
        <ZoomInRoundedIcon />
      </IconButton>
    </Stack>
  )
}

export default ZoomButtons
